import { createFileRoute } from '@tanstack/react-router';
import { CustomerPage } from '@web/modules/customers/detail/customer-page';

interface CustomerSearch {
  /** Just created by the quick create: the page invites to complete the record. */
  created?: true;
  /** A ticket to open in the drawer on arrival (a search hit). */
  ticket?: string;
}

export const Route = createFileRoute('/_app/customers/$customerId')({
  validateSearch: (search: Record<string, unknown>): CustomerSearch => ({
    ...(search['created'] === true || search['created'] === 'true'
      ? { created: true as const }
      : {}),
    ...(typeof search['ticket'] === 'string' && search['ticket'] !== ''
      ? { ticket: search['ticket'] }
      : {}),
  }),
  component: CustomerRoute,
});

function CustomerRoute() {
  const { customerId } = Route.useParams();
  const { created, ticket } = Route.useSearch();
  // Keyed by id: another customer starts with fresh sections (nothing being edited).
  return (
    <CustomerPage
      key={customerId}
      customerId={customerId}
      justCreated={created === true}
      openTicketId={ticket ?? null}
    />
  );
}
